/* RingConn dynamic-copy adapter. Translations live in per-language JSON assets.
 * No theme ID dependency. Never changes form values, links, prices or event bindings.
 * This is a compatibility layer, not a replacement for native resource translations. */
(() => {
  'use strict';
  const element = document.getElementById('ringconn-localization-config');
  if (!element) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch (_) { return; }
  if (!config.enabled || config.locale !== document.documentElement.lang) return;
  if (window.__ringconnLocalizationStarted) return;
  window.__ringconnLocalizationStarted = true;
  fetch(config.messagesUrl, {credentials:'omit'})
    .then(response => { if (!response.ok) throw new Error('Localization dictionary unavailable'); return response.json(); })
    .then(catalog => {
      if (catalog.version !== 1 || catalog.locale !== config.locale || !catalog.pages || !Array.isArray(catalog.pages.GLOBAL)) return;
      initialize(catalog.pages);
    })
    .catch(() => { /* Keep original server-rendered content if a dictionary cannot load. */ });
  function initialize(pages) {
  const normalize = s => String(s || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const alternate = document.querySelector('link[rel="alternate"][hreflang="en"]');
  let path = location.pathname;
  const prefix = String(config.root || '/').replace(/\/$/, '');
  if (prefix && path.startsWith(prefix + '/')) path = path.slice(prefix.length) || '/';
  else if (prefix && path === prefix) path = '/';
  try { if (alternate) path = new URL(alternate.href).pathname; } catch (_) {}
  if (!pages[path]) return;
  const map = new Map([...pages[path], ...pages.GLOBAL]);
const protectedLanguage = '.language-option-button .language';const forbidden =  'script,style,noscript,template,svg,textarea,input,select,' +  '[contenteditable="true"],.shopify-preview-bar,' +  protectedLanguage;

  const eligible = el => el && !el.closest(forbidden);
  const preserve = (old, value) => (old.match(/^\s*/)?.[0] || '') + value + (old.match(/\s*$/)?.[0] || '');
  const lookup = text => {
    const n = normalize(text);
    // Remove only the literal protection tags leaked by translation tooling.
    // This operates on text, never on HTML markup or interactive attributes.
    const clean = n.replace(/<\/?tc>/gi, '');
    const t = map.get(n) || map.get(clean);
    const result = t ? t.replace(/<\/?tc>/gi, '') : clean;
    return result !== n ? result : null;
  };
  const leaf = node => {
    if (!eligible(node.parentElement)) return;
    const t = lookup(node.nodeValue);
    if (t) node.nodeValue = preserve(node.nodeValue, t);
  };
  const combined = el => {
     if (el.querySelector(protectedLanguage)) return;
    // Never move text across links, buttons, controls, images or custom elements.
    if (!eligible(el) || [...el.querySelectorAll('*')].some(c => !['SPAN','BR','STRONG','EM','B','I','SMALL','SUP','SUB'].includes(c.tagName))) return;
    const t = lookup(el.textContent);
    if (!t) return;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const nodes = [];
    for (let n = walker.nextNode(); n; n = walker.nextNode()) if (normalize(n.nodeValue)) nodes.push(n);
    if (!nodes.length) return;
    // Preserve every existing element, listener and attribute. Only text changes.
    nodes[0].nodeValue = preserve(nodes[0].nodeValue, t);
    for (const n of nodes.slice(1)) n.nodeValue = '';
  };
  const run = root => {
    if (!root || !root.isConnected) return;
    if (root.nodeType === 3) root = root.parentElement;
    if (!eligible(root)) return;
    // Whole phrases must be checked BEFORE translating their component words.
    const elements = [root, ...root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,label,summary,a,button,li,th,td,div,span')];
    for (const el of elements) combined(el);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let n = walker.nextNode(); n; n = walker.nextNode()) leaf(n);
    // Explicit option values remain untouched; implicit-value options are skipped.
    for (const option of root.querySelectorAll('select option[value]')) {
      const t = lookup(option.textContent);
      if (t && option.childNodes.length === 1 && option.firstChild.nodeType === 3)
        option.firstChild.nodeValue = preserve(option.firstChild.nodeValue, t);
    }
    for (const el of [root, ...root.querySelectorAll('[placeholder],[aria-label],[title],[alt]')]) {
      if (!eligible(el) && !el.matches('input[placeholder]')) continue;
      for (const attr of ['placeholder','aria-label','title','alt']) {
        const old = el.getAttribute(attr), t = old && lookup(old);
        if (t) el.setAttribute(attr, t);
      }
    }
  };
  const start = () => {
    run(document.body);
    const pending = new Set();
    let scheduled = false;
    const flush = () => {
      scheduled = false;
      const roots = [...pending]; pending.clear();
      for (const root of roots) if (!roots.some(other => other !== root && other.contains(root))) run(root);
    };
    // Keep observing late-opened dialogs; batch only the affected subtrees.
    new MutationObserver(changes => {
      for (const change of changes) {
        const el = change.target.nodeType === 3 ? change.target.parentElement : change.target;
        if (eligible(el)) pending.add(el);
      }
      if (pending.size && !scheduled) { scheduled = true; requestAnimationFrame(flush); }
    }).observe(document.body, {childList:true, characterData:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  }
})();
